import React, { useMemo } from 'react';

interface BrowsingHistoryProps {
  browsingListoryList: any[];
  themeColorStyle: any;
}

const BrowsingHistory: React.FC<BrowsingHistoryProps> = React.memo(({ browsingListoryList, themeColorStyle }) => {
  const displayedItems = useMemo(() => browsingListoryList.slice(0, 3), [browsingListoryList]);

  return (
    <>
      <p className={"text-14 text-left text-[#333] w-[76px]"}>瀏覽記錄</p>
      <div className={"flex flex-wrap"}>
        {displayedItems.map((item: any, index: number) => (
          <React.Fragment key={item.kindId}>
            {index < 3 && (
              <div
                className={"cursor-pointer rounded-4 mr-10 text-14 text-white py-2 px-8 mb-14"}
                style={{
                  background: themeColorStyle.current.background,
                  opacity: 0.6,
                }}
              >
                <a
                  className="text-white hover:text-white"
                  key={item.kindId}
                  href={item.summaryLink}
                  target='_blank'
                >{`${item.brandName} ${item.kindName}`}</a>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
});

export default BrowsingHistory;
